import styled from 'styled-components'

export const HeaderWrapper = styled.header`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  flex-basis: 100%; // fill all available width

  height: ${({ theme }) => theme.misc.header.height};
  min-height: ${({ theme }) => theme.misc.header.height};
  max-height: ${({ theme }) => theme.misc.header.height};

  padding: ${({ theme }) => `0 ${theme.spacings[8]}`};

  color: #3c3c3c;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 21px;
    left: 21px;
    height: 2px;
    max-height: 2px;
    min-height: 2px;
    background-color: #d8d8d8;
    z-index: 1;
  }

  h1 {
    margin: 0;
    font-size: 18px;
    weight: 700;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.primary};
    ]
  }

  img {
    width: 180px;
  }

  nav {
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacings[4]};

    a {
      color: #3c3c3c;
      line-height: 0;
    }

    button {
      position: relative;
      color: #3c3c3c;
      line-height: 0;

      &[data-count]:not([data-count='0']) {
        &::after {
          display: flex;
          align-items: center;
          justify-content: center;

          font-size: ${({ theme }) => theme.fontSizes.xsm};
          font-weight: bold;

          content: attr(data-count);

          position: absolute;
          top: 4px;
          right: 0px;

          height: 16px;
          width: 16px;

          border-radius: 50%;

          line-height: 0;

          color: #fff;
          background-color: #3FA73A;
        }
      }
    }

    svg {
      height: ${({ theme }) => theme.fontSizes.lg};
    }
  }
`

export const HeaderUser = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 12px 0 20px;

  div:first-of-type {
    display: flex;
    flex-direction: column;
    gap: 2px;

    text-align: right;

    strong {
      font-size: 18px;
      text-weight: 600;
      color: #272727;
    }
  }
`
